<template>
  <section class="schedule-container">
    <base-header v-bind="headers"
      v-on:handleLink="handleHeaderLink"
    />
    <div class="block">
      <div class="title">
        <span class="icon jee-hover-color" @click="pervMonth"><</span>
        <span class="date">{{this.now.year}}年{{this.now.month}}月</span>
        <span class="icon jee-hover-color" @click="nextMonth">></span>
      </div>
      <div class="main">
        <ul class="week">
          <li>周日</li>
          <li>周一</li>
          <li>周二</li>
          <li>周三</li>
          <li>周四</li>
          <li>周五</li>
          <li>周六</li>
        </ul>
        <ul class="list">
          <li v-for="(item, index) in list" :class="item.active ? item.notices.length > 0 ? 'edit' : '' : 'disabled'" :key="index">
            <div class="day">{{item.dateName}}</div>
            <div class="button" v-if="item.notices.length === 0 && item.active">
              <span class="jee-color" @click="addRecord(item)">添加</span>
            </div>
            <div class="button" v-else-if="item.active">
              <span class="jee-color" @click="editRecord(item)">修改</span>
              <span class="jee-color" @click="delRecord(item)">删除</span>
            </div>
            <div class="state" v-if="item.active && item.notices.length > 0 && item.notices[0].status === 3">未发送</div>
          </li>
        </ul>
      </div>
    </div>
    <form-dialog
      :title="addFormTitle"
      ref="addDialog"
      width="800px"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :buttons="addButtons"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
      v-on:handleConfirmSave="handleConfirmSave"
    ></form-dialog>
    <form-dialog
      :title="detailFormTitle"
      ref="detailDialog"
      :buttons="detailButtons"
    >
    <div class="dialog-box">
      <div class="dialog-header">
        <div class='title'>{{message.title}}</div>
        <p><span class="label">发送时间</span>：<span>{{message.showTime}}</span></p>
      </div>
      <div class="dialog-content">
        <p>
          {{message.content}}
        </p>
      </div>
    </div>
    </form-dialog>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import msgDialog from '@/components/mixins/msgDialog'
import formDialog from '@/components/mixins/formDialog'

export default {
  name: 'schedule',
  mixins: [baseHeader, formDialog, msgDialog],
  data () {
    return {
      list: [],
      after: {},
      pre: {},
      now: {},
      addFormLoading: false,
      addFormTitle: '添加通知',
      addForm: {
        'title': '',
        'content': '',
        'beforeDay': '',
        'id': '',
        'date': ''
      },
      addButtons: [
        {
          text: '存为草稿',
          type: 'Save'
        },
        {
          text: '发送通知',
          type: 'Submit'
        }
      ],
      addRules: {
        title: [
          this.$rules.required()
        ],
        content: [
          this.$rules.required()
        ],
        beforeDay: [
          this.$rules.required()
        ]
      },
      addFormItems: [
        {
          type: 'radio',
          prop: 'beforeDay',
          label: '发送日期',
          options: [
            {
              label: '马上送达',
              value: 0
            },
            {
              label: '提前1天',
              value: 1
            },
            {
              label: '提前3天',
              value: 3
            },
            {
              label: '提前5天',
              value: 5
            }
          ]
        },
        {
          prop: 'title',
          label: '通知标题',
          placeholder: '',
          maxlength: 50,
          style: {
            width: '500px',
            maxWidth: '500px'
          }
        },
        {
          prop: 'content',
          type: 'textarea',
          label: '通知内容',
          maxlength: 5000,
          width: '500px',
          placeholder: '请输入通知内容，5000字以内'
        }
      ],
      detailFormTitle: '查看通知',
      detailButtons: [],
      headers: {
        buttons: [
          {
            type: 'Link',
            text: '查看全部',
            icon: '',
            notDisabled: true,
            href: '/oabusiness/schedule/list'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      },
      message: {}
    }
  },
  activated () {
  },
  methods: {
    addRecord (item) {
      this.addFormTitle = `添加通知（${this.now.year}年${this.now.month}月${item.dateName}日）`
      this.addForm = {
        'title': '',
        'content': '',
        'beforeDay': '',
        'id': '',
        'date': item.strDate
      }
      this.addButtons[0].disabled = false
      this.$refs.addDialog.showDialog()
    },
    editRecord (item) {
      this.addFormTitle = `修改通知（${this.now.year}年${this.now.month}月${item.dateName}日）`
      this.addForm = {
        'title': item.notices[0].title,
        'content': item.notices[0].content,
        'beforeDay': item.notices[0].beforeShowTime,
        'id': item.notices[0].id,
        'date': item.strDate
      }
      this.addButtons[0].disabled = item.notices[0].status === 1
      this.$refs.addDialog.showDialog()
    },
    detailRecord (item) {
      this.detailFormTitle = `查看通知（${item.notices[0].noticeTime}）`
      this.message = {
        'title': item.notices[0].title,
        'content': item.notices[0].content,
        'showTime': item.notices[0].showTime
      }
      this.$refs.detailDialog.showDialog()
    },
    handleConfirmAdd (data, btn, type) { // 新增用户
      this.addFormLoading = true
      var params = Object.assign({}, data)
      let api = data.id ? 'fetchOabuinessScheduleUpdate' : 'fetchOabuinessScheduleAdd'
      this.$request[api](params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchOabuinessScheduleList(this.now)
        }
        this.addFormLoading = false
      }).catch(() => {
        this.addFormLoading = false
      })
    },
    handleConfirmSave (data, btn, type) {
      this.addFormLoading = true
      var params = Object.assign({}, data)
      this.$request.fetchOabuinessScheduleSave(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchOabuinessScheduleList(this.now)
        }
        this.addFormLoading = false
      }).catch(() => {
        this.addFormLoading = false
      })
    },
    fetchOabuinessScheduleList (params) {
      this.$request.fetchOabuinessScheduleList(params).then(res => {
        if (res.code === 200) {
          console.log(res)
          this.now = params
          this.list = res.data.details
          this.after = res.data.after
          this.pre = res.data.pre
        }
      })
    },
    pervMonth () {
      this.fetchOabuinessScheduleList(this.pre)
    },
    nextMonth () {
      this.fetchOabuinessScheduleList(this.after)
    },
    delRecord (row) {
      this.msgDialog.content = '确认删除吗？'
      this.msgDialog.data = row.notices[0].id
      this.showMsgDialog()
    },
    // 弹出框操作按钮
    handleConfirmMsg () {
      let params = {
        id: this.msgDialog.data
      }
      this.$request.fetchOabuinessScheduleDel(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchOabuinessScheduleList(this.now)
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      })
    }
  },
  mounted () {
    this.now = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    }
    this.fetchOabuinessScheduleList(this.now)
  }
}
</script>
<style lang="scss" scoped>
  .schedule-container{
    .block {
      .title {
        color:#4a4a4a;
        font-size: 24px;
        line-height: 30px;
        display: flex;
        align-items: center;
        .date {
          margin: 0 20px;
        }
        .icon {
          display: block;
          width: 18px;
          height: 30px;
          cursor: pointer;
        }
      }
      .main {
        .week {
          margin-top: 14px;
          height: 20px;
          display: flex;
          font-size:14px;
          line-height: 20px;
          color:#4a4a4a;
          width: 910px;
          li {
            width: 130px;
            text-align: center;
          }
        }
        .list {
          margin-top: 10px;
          display: flex;
          width: 912px;
          border-left:1px solid #e5e5e5;
          border-bottom:1px solid #e5e5e5;
          box-sizing: border-box;
          flex-wrap: wrap;
          justify-content: flex-start;
          li {
            position: relative;
            width: 130px;
            text-align: center;
            height: 84px;
            border-right:1px solid #e5e5e5;
            border-top:1px solid #e5e5e5;
            padding: 14px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .day {
              font-size:18px;
              line-height: 18px;
              color:#4a4a4a;
            }
            .button {
              display: flex;
              justify-content: center;
              span {
                display: block;
                cursor: pointer;
                margin: 0 2px;
              }
            }
            .state {
              position: absolute;
              bottom: 0;
              right: 0;
              color: #fff;
              font-size: 14px;
              background-color: #ccc;
            }
          }
          .disabled {
            background:#f0f0f0;
            .day {
              color:#9b9b9b;
            }
          }
          .edit {
            background:#ffffec;
            .button {
              span {
                color:#ff9000 !important;
              }
            }
          }
        }
      }
    }
    .dialog-box{
      border:1px solid rgba(237,237,237,1);
      border-radius:0px 0px 4px 4px;
      .dialog-header{
        padding: 20px;
        border-bottom: 1px solid rgba(237,237,237,1);
        background:rgba(250,250,250,1);
        .title{
          color: #333333;
          font-size: 16px;
          font-weight: 600;
        }
        .label{
          color: #999999;
          width: 70px;
          font-size: 14px;
          display: inline-block;
          margin-top: 10px;
          text-align-last: justify;
        }
        span{
          color: #333333;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .dialog-content{
        overflow: scroll;
        max-height: 355px;
        p{
          text-indent:28px;
          font-size: 14px;
          color: #333333;
          padding: 20px;
        }
      }
    }
  }
</style>
